<template>
  <div>
    <confirm-remove :showRemoveDialog="showRemoveDialog" @confirm="removePatient" @close="showRemoveDialog = false"></confirm-remove>
    <select-tag :showTagDialog="showTagDialog" @addTag="addTag" @close="showTagDialog = false"></select-tag>
    <md-card class="card-container">
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <page-title :title="isEditing ? '修改客戶' : '新增客戶'"></page-title>
        </div>
        <div class="md-layout-item float-right">
          <md-button v-if="isEditing && hasScope('PATIENT_UPSERT')" class="md-raised md-accent float-right" @click="showRemoveDialog = true">刪除客戶</md-button>
          <md-button v-if="isEditing" class="md-raised md-primary float-right" @click="goViewRecord">服務紀錄</md-button>
        </div>
      </div>
      <div>
        <md-tabs>
          <md-tab md-label="基本資訊">
            <div class="md-layout md-gutter">
              <div class="md-layout-item">
                <md-field>
                  <label>姓名</label>
                  <md-input v-model="data.name"></md-input>
                </md-field>
              </div>
              <div class="md-layout-item">
                <md-field>
                  <label>客戶編號</label>
                  <md-input v-model="data.id_alt"></md-input>
                </md-field>
              </div>
              <div class="md-layout-item">
                <md-datepicker v-model="data.birthday">
                  <label>生日</label>
                </md-datepicker>
              </div>
            </div>
            <div class="md-layout md-gutter">
              <div class="md-layout-item">
                <md-field>
                  <label>性別</label>
                  <md-select v-model="data.gender">
                    <md-option :value="'m'">男</md-option>
                    <md-option :value="'f'">女</md-option>
                  </md-select>
                </md-field>
              </div>
              <div class="md-layout-item">
                <md-field>
                  <label>身分證字號</label>
                  <md-input v-model="data.id_number"></md-input>
                </md-field>
              </div>
              <div class="md-layout-item">
                <md-field>
                  <label>電話</label>
                  <md-input v-model="data.phone_number"></md-input>
                </md-field>
              </div>
            </div>
            <div class="md-layout md-gutter">
              <div class="md-layout-item">
                <md-field>
                  <label>Line ID</label>
                  <md-input v-model="data.line_id"></md-input>
                </md-field>
              </div>
              <div class="md-layout-item">
                <md-field>
                  <label>電子信箱</label>
                  <md-input v-model="data.email"></md-input>
                </md-field>
              </div>
            </div>
            <div class="md-layout md-gutter">
              <div class="md-layout-item">
                <md-field>
                  <label>主要陪同人/緊急聯絡人/地址/學校/其他訊息</label>
                  <md-textarea v-model="data.emergency_contact"></md-textarea>
                </md-field>
              </div>
            </div>
            <div class="md-layout md-gutter">
              <div class="md-layout-item">
                <md-field>
                  <label>主要症狀</label>
                  <md-textarea v-model="data.main_problem"></md-textarea>
                </md-field>
              </div>
            </div>
          </md-tab>
          <md-tab md-label="標籤">
            <md-table v-if="data.tag.length > 0">
              <md-table-row>
                <md-table-head>名稱</md-table-head>
                <md-table-head>類別</md-table-head>
                <md-table-head></md-table-head>
              </md-table-row>
              <md-table-row v-for="(tag, index) in data.tag" :tags="data.tag" :key="tag.id">
                <md-table-cell>
                  <router-link :to="`/tag/${tag.id}`">
                    {{tag.name}}
                  </router-link>
                </md-table-cell>
                <md-table-cell>
                  <a v-bind:style="{backgroundColor: `#${tag.tag_group.color}`}">
                    {{tag.tag_group.name}}
                  </a>
                </md-table-cell>
                <md-table-cell>
                  <a @click="removeTag(index)">
                    移除標籤
                  </a>
                </md-table-cell>
              </md-table-row>
            </md-table>
            <div class="md-layout md-gutter">
              <div class="md-layout-item">
                <md-button
                  class="md-raised md-primary"
                  @click="showTagDialog = true"
                  v-if="hasScope('RECORD_UPSERT')"
                >新增標籤</md-button>
              </div>
            </div>
          </md-tab>
          <md-tab md-label="ORS 測驗" v-if="isEditing">
            <div>
              <ors-charts :patientID="isEditing"></ors-charts>
            </div>
          </md-tab>
        </md-tabs>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <md-button class="md-raised md-danger" @click="goPatientList">返回</md-button>
          <md-button v-if="isEditing && hasScope('RECORD_UPSERT')" class="md-raised md-primary" @click="goAddRecord">新增紀錄</md-button>
        </div>
        <div class="md-layout-item" v-if="hasScope('PATIENT_UPSERT')">
          <md-button v-if="isEditing" class="float-right md-raised md-primary" @click="editPatient">送出</md-button>
          <md-button v-else class="float-right md-raised md-primary" @click="createPatient">送出</md-button>
        </div>
      </div>
    </md-card>
  </div>
</template>

<script>
import PageTitle from '@/components/Shared/PageTitle'
import OrsCharts from '@/components/Patient/OrsCharts'
import ConfirmRemove from '@/components/Shared/ConfirmRemove'
import axios from 'axios'
import { mapMutations } from 'vuex'
import urls from '@/urls'
import moment from 'moment'
import SelectTag from '@/components/Patient/SelectTag'
import { hasScope } from '@/services/auth'

export default {
  data () {
    return {
      isEditing: null,
      showTagDialog: false,
      showRemoveDialog: false,
      data: {
        name: null,
        id_alt: null,
        birthday: null,
        id_number: null,
        phone_number: null,
        email: null,
        line_id: null,
        photo_url: null,
        emergency_contact: null,
        main_problem: null,
        tag: []
      },
      tags: [],
      record: [],
      selectedTag: null
    }
  },
  components: {
    PageTitle, OrsCharts, ConfirmRemove, SelectTag
  },
  created: function () {
    if (this.$route.params.id !== 'add') {
      this.isEditing = this.$route.params.id
    }
    if (this.isEditing) {
      this.readPatient(this.isEditing)
      this.getRecord()
    }
    this.getTag()
  },
  methods: {
    hasScope,
    dateConvert: function (date) {
      let from = moment(date[0]).format('YYYY-MM-DD HH:MM')
      let until = moment(date[1]).format('YYYY-MM-DD HH:MM')
      return `${from} - ${until}`
    },
    getRecord: async function () {
      let req = await axios.get(urls({route: 'record'}), {params: {patient_id: this.isEditing}})
      if (req.status === 200) {
        this.record = req.data.data
      }
    },
    ...mapMutations('patient', {
      setPatientData: 'setPatientData'
    }),
    removeTag (index) {
      this.data.tag.splice(index, 1)
    },
    goPatientList () {
      this.$router.push('/patient')
    },
    goAddRecord () {
      this.$router.push('/record/add')
    },
    removePatient: async function () {
      let req = await axios.delete(urls({route: 'patient', id: this.isEditing}))
      if (req.status === 200) {
        this.goPatientList()
      }
    },
    createPatient: async function () {
      let req = await axios.post(urls({route: 'patient'}), {
        ...this.data,
        birthday: moment(this.data.birthday).format('YYYY-MM-DD')
      })
      if (req.status === 201) {
        this.goPatientList()
      }
    },
    readPatient: async function (patientID) {
      let req = await axios.get(urls({route: 'patient', id: patientID}))
      this.data = req.data.data
      this.setPatientData({
        id: this.data.id,
        id_alt: this.data.id_alt,
        name: this.data.name
      })
    },
    editPatient: async function () {
      let req = await axios.put(urls({route: 'patient', id: this.isEditing}), {
        ...this.data,
        birthday: moment(this.data.birthday).format('YYYY-MM-DD')
      })
      if (req.status === 200) {
        this.goPatientList()
      }
    },
    addTag (tag) {
      if (this.data.tag.find(i => i.id === tag.id)) {
        return
      }
      this.data.tag.push(tag)
    },
    getTag: async function () {
      let req = await axios.get(urls({route: 'tag'}))
      this.tags = req.data.data
    },
    goViewRecord: async function () {
      this.$store.commit('RecordList/updatePatientId', this.isEditing)
      this.$store.commit('RecordList/updatePatientName', this.data.name)
      this.$store.commit('RecordList/dontClear', true)
      let routeData = this.$router.resolve({'name': 'RecordList'})
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Patient/PatientEdit.vue